import React, {Component} from "react";
import {Form, Input , Radio,Row,Col} from 'antd';
import NHFetch from "../../../utils/NHFetch";

const FormItem = Form.Item;

const baseUrlPath = "/swbl/lstd"; //基础路径

/**
 * 绿色通道查看表单
 * @author admin
 * @date 2018-03-16 11:28:34
 * Version: 1.0
 */
class ViewForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            /* blyy:'',
            fj:[], */
        }
    }
    componentWillMount(){
        //根据lstdid 获取办理原因
        /* let initFormData = this.props.initFormData;
        NHFetch(`/swbl/lstd/lstdblyy/${initFormData.PKID}/getBlyyStr`,"get").then(res=>{
            if(res){
                this.setState({blyy:res.data});
            }
        })

        NHFetch(`/swbl/lstd/${initFormData.PKID}/getFjList`,"get").then(res=>{
            console.lo;
            if(res){
                this.setState({fj:res.data});
            }
        }) */

    }

    // 下载文件
    handlePreview = (fjmc, fjid) => {
        window.open(`api/docrepo/download/file?attachmentId=${fjid}`);
    };

    render() {
        const initFormData = this.props.initFormData;
        console.log("initFormData-------",initFormData);
        let fjList = [];
        if(JSON.stringify(initFormData) != "{}"){
            let fj =  initFormData['WSSQFJ'];
            console.log(fj);
            if(fj){
                fjList = JSON.parse(fj);
            }
        }
        return (
            <div>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}> 姓名(学号)：</Col>
                    <Col span={8}>{initFormData.XM}{initFormData.XH}</Col>
                    <Col span={4} style={{textAlign:'right'}}>性别：</Col>
                    <Col span={8}>{initFormData.XBMMC}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>学院：</Col>
                    <Col span={8}>{initFormData.BMMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>专业：</Col>
                    <Col span={8}>{initFormData.ZYMC}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>班级：</Col>
                    <Col span={8}>{initFormData.BJMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>年度：</Col>
                    <Col span={8}>{initFormData.ND}</Col>
                </Row>
                <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>是否住宿：</Col>
                    <Col span={8}>{initFormData.SFZS && initFormData.SFZS=="0" ? "否": "是"}</Col>
                </Row>
                {initFormData && initFormData.SFZS=='0' && <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>潜江详细地址：</Col>
                    <Col span={8}>{initFormData.WSDZ}</Col>
                    <Col span={4} style={{textAlign:'right'}}>监护人：</Col>
                    <Col span={8}>{initFormData.JHR}</Col>
                </Row>}
                {initFormData && initFormData.SFZS=='0' && <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                    <Col span={4} style={{textAlign:'right'}}>与监护人关系：</Col>
                    <Col span={8}>{initFormData.JHRGXMC}</Col>
                    <Col span={4} style={{textAlign:'right'}}>监护人电话：</Col>
                    <Col span={8}>{initFormData.JHRDH}</Col>
                </Row>}
                {initFormData && initFormData.SFZS=='0' && <Row gutter={24}>
                    <Col span={4} style={{textAlign: 'right', paddingRight: 0}}><span
                        style={{color: 'rgba(0, 0, 0, 0.85)'}}>附件走读申请书&nbsp;: </span></Col>
                    <Col span={20}>
                        {fjList.length>0 && fjList.map((elem, index) => {
                            return (
                                <div style={{marginBottom: '20px'}}>
                                    <a onClick={() => {
                                        this.handlePreview(elem['fjmc'], elem['fjid']);
                                    }}>{elem['fjmc']}</a>
                                </div>
                            )
                        })
                        }
                    </Col>
                </Row>}
                <div>
                    <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                        <Col span={4} style={{textAlign:'right'}}>审核状态：</Col>
                        <Col span={8}>{initFormData.SHZTMC}</Col>
                        <Col span={4} style={{textAlign:'right'}}>审核时间：</Col>
                        <Col span={8}>{initFormData.SHSJ}</Col>
                    </Row>
                    <Row style={{marginBottom:'24px',fontSize:'14px',lineHeight:'1.5'}}>
                        <Col span={4} style={{textAlign:'right'}}>审核意见：</Col>
                        <Col span={20}>{initFormData.SHYJ}</Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default ViewForm;


// WEBPACK FOOTER //
// ./components/swbl/sfzs/ViewForm.js